import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { UserOrganizationView } from '@api-proxies';
import { IconSanitizerService, TooltipDirective, TooltipPosition } from 'ngx-lib';

@Component({
    selector: 'app-organization-item',
    templateUrl: './organization-item.component.html',
    styleUrls: ['./organization-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TooltipDirective, NgOptimizedImage]
})
export class OrganizationItemComponent {
    readonly organization = input<UserOrganizationView | undefined>(undefined);
    readonly orgNameTooltipPosition = input<TooltipPosition>(TooltipPosition.ABOVE);
    readonly iconSanitizer = inject(IconSanitizerService);
    readonly organizationLogoIcon: SafeHtml = this.iconSanitizer.getIcon('organizationLogo');
}
